import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import RegisteredAction from 'src/app/model/registered-action';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { OfflineTaskChangesObject } from '../../offline-storage/offline-task-changes-object';
import { SubmitRequestRegisteredAction } from './helper-interfaces/submit-request-registered-action';
import { TaskSubmitHelper } from './task-submit-helper';
import { Observable } from 'rxjs';
import { _put } from '../../../../base.service';

@Injectable({
  providedIn: 'root',
})
export class SubmitRegisteredActionsService {
  private static BASE_URL = '/task';
  private readonly put: <T>(
    path: string,
    body: SubmitRegisteredActionsRequestBody,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly deserialize = (res) => res as RegisteredAction[];

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.put = _put(SubmitRegisteredActionsService.BASE_URL, requestServices);
  }

  public submit(
    taskChanges: OfflineTaskChangesObject
  ): Promise<RegisteredAction[]> {
    if (!CollectionHelper.isPopulated(taskChanges.registeredActions)) {
      return Promise.reject(
        new Error(`No registered actions provided for task ${taskChanges.id}`)
      );
    }
    const requestBody: SubmitRegisteredActionsRequestBody = {
      taskId: taskChanges.id,
      registeredActions: taskChanges.registeredActions.map((r) =>
        TaskSubmitHelper.mapToSubmitRequestRegisteredAction(r)
      ),
    };
    return this.put(
      '/submitRegisteredActions',
      requestBody,
      this.deserialize
    ).toPromise();
  }
}

export interface SubmitRegisteredActionsRequestBody {
  taskId: number;
  registeredActions: SubmitRequestRegisteredAction[];
}
